import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { withJsonpSupport, withInterceptors } from '@angular/common/http';
import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';

import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { environment } from '../environments/environment';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ToastsComponent } from './components/toasts/toasts.component';
import { HeaderComponent } from './components/header/header.component';
import { SideBarDesktopComponent } from './components/side-bar-desktop/side-bar-desktop.component';
import { SideBarMobileComponent } from './components/side-bar-mobile/side-bar-mobile.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import Aura from '@primeng/themes/aura';
import { provideHttpClient } from '@angular/common/http';
import { PasoModalComponent } from './moudules/admin/modules/empresa/components/paso-modal/paso-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    AdminLayoutComponent,
    SpinnerComponent,
    ToastsComponent,
    HeaderComponent,
    SideBarDesktopComponent,
    SideBarMobileComponent,
    MenuItemComponent,
    PasoModalComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    SharedModule
  ],
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
    UserTrackingService,
    provideHttpClient(withJsonpSupport()),
    provideAnimationsAsync(),
    providePrimeNG({ 
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      }
    }),
     provideHttpClient(
        withInterceptors([httpErrorInterceptor])
      )
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
